import * as React from 'react'
import { InfoMessage } from "../model/Message";
import { FaYammer, FaQuestion } from "react-icons/fa";

export const messageServiceMessage = InfoMessage(
    <span>News and updates</span>,
    <span>
        We want to keep you informed about updates to SMART.
        To help us do that, you will occasionally see a message like this one.
        Once you have read the message, you can dismiss it with the x in the top right corner.
    </span>,
    new Date(Date.UTC(2019, 9, 16))
);

export const downtimeWelcomeMessage = InfoMessage(
    <span>Welcome to the new SMART downtime editing page</span>,
    <span>
        This replaces the legacy alarm editing page.
    </span>,
    new Date(Date.UTC(2019, 9, 16))
);

export const mvcLinkMessage = InfoMessage(
    <span>Legacy alarm page links on help page <FaQuestion/></span>,
    <span>
        The legacy alarm page can still be accessed via the <FaQuestion/> icon if necessary.
    </span>,
    new Date(Date.UTC(2019, 9, 16))
);

export const yammerChannelMessage = InfoMessage(
    <span>Yammer channel link <FaYammer/></span>,
    <span>
        Please share any feedback on the SMART users Yammer channel with the <FaYammer/> icon.
    </span>,
    new Date(Date.UTC(2019, 9, 16))
);
